module.exports = __webpack_public_path__ + "fonts/Roboto-Bold.a8408b4.eot";